var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___WDJJbn",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___WDJJbn",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___WDJJbn",
  "eb": "FavoritesChannelListContent.module__favoriteItem___WDJJbn",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___WDJJbn",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___WDJJbn",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___WDJJbn",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___WDJJbn",
  "H": "FavoritesChannelListContent.module__avatarContainer___WDJJbn",
  "my": "FavoritesChannelListContent.module__avatar___WDJJbn",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___WDJJbn",
  "XQ": "FavoritesChannelListContent.module__channelBadge___WDJJbn",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___WDJJbn",
  "QC": "FavoritesChannelListContent.module__displayName___WDJJbn",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___WDJJbn",
  "af": "FavoritesChannelListContent.module__categoryItem___WDJJbn",
  "Yq": "FavoritesChannelListContent.module__categoryContent___WDJJbn",
  "yb": "FavoritesChannelListContent.module__categoryName___WDJJbn",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___WDJJbn",
  "wp": "FavoritesChannelListContent.module__categoryActions___WDJJbn",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___WDJJbn",
  "It": "FavoritesChannelListContent.module__categoryAddButton___WDJJbn",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___WDJJbn",
  "NP": "FavoritesChannelListContent.module__navigationContainer___WDJJbn",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___WDJJbn",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___WDJJbn",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___WDJJbn",
};

module.exports = exports;
